export const CLOSE_MESSAGE = 'CLOSE_MESSAGE'
export const OPEN_MESSAGE = 'OPEN_MESSAGE'



// WEBPACK FOOTER //
// ./src/types/message.js